import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Typography, Button } from '@material-ui/core';
import { CSVLink } from 'react-csv';
import { toStartCase } from 'util/string';

export const useStyles = makeStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  body: {
    // TODO: borderRight: `1px solid #f8f8f8`
  }
}));

function renderObject(value) {
  if(Array.isArray(value)) {
    return <ol>{value.map(val => (<li>{renderObject(val)}</li>))}</ol>;
  }
  if(value && typeof value === 'object') {
    return <ul>{Object.keys(value).map(key => (<li>{key}: {renderObject(value[key])}</li>))}</ul>;
  }
  return value;
}


export function TableList({ entities, columns, onClick, exportColumns, exportFileName }) {
  const classes = useStyles();

  columns = columns || (entities && entities[0] && Object.keys(entities[0]).map(name => ({name}))) || [];
  exportColumns = exportColumns || columns;

  const getTitle = (column) => column.title || toStartCase(column.name);
  const getValue = (column, entity) => renderObject(column.value ? column.value(entity) : entity[column.name]);

  const csvHeaders = exportColumns && exportColumns.map(column => ({label: getTitle(column), key: column.name}));
  // TODO: optimize
  const csvEntities = entities && entities.map((entity, index) => (
    columns.reduce((newEntity, column) => {
      newEntity[column.name] = getValue(column, entity);
      return newEntity;
    }, {})
  ));

  return !!entities && (
    <TableContainer component={Paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow key={'headers'}>
            {columns.map(column => (<TableCell key={column.name} className={classes.head}>{getTitle(column)}</TableCell>))}
          </TableRow>
        </TableHead>
        <TableBody>
          {entities.map((entity, index) => (
            <TableRow key={entity.id}> 
              {columns
                .map(column => (
                  <TableCell key={column.name + index} onClick={() =>  onClick({entity, column})/* TODO: */ }>
                    {getValue(column, entity)}
                  </TableCell>)
                )}
            </TableRow>)
          )}
        </TableBody>
      </Table>
      {!entities.length && (
        <Box p={1} display="flex" justifyContent="center">
          <Typography>None</Typography>
        </Box>
      )}
      {csvEntities && exportFileName && (
        <Box p={1} display="flex">
          <Button variant="contained" size="small">
            <CSVLink 
              headers={csvHeaders} data={csvEntities} filename={exportFileName || "export.csv"}
              style={{color: 'inherit', textDecoration: 'none'}}
            >
              Export
            </CSVLink>
          </Button>
        </Box>
      )}
    </TableContainer>
  );
}
